import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageProvider";

// Official Dentel Vietnam horizontal lockup (tooth icon + "DENTAL VIETNAM" wordmark).
// Transparent PNG, native size 2000×727 (aspect ratio ~2.751 W:H).
// Rendered as a background-image on a fixed-size box for reliable, undistorted paint.
const LOGO_SRC = "/logo-dentel-vietnam.png?v=3";

export default function Logo({ variant = "dark", className = "" }) {
  const { p } = useI18n();
  const onDark = variant === "light";

  const mark = (sizeClasses) => (
    <span
      role="img"
      aria-label="Dentel Vietnam"
      style={{ backgroundImage: `url("${LOGO_SRC}")` }}
      className={`block bg-contain bg-left bg-no-repeat ${sizeClasses}`}
    />
  );

  return (
    <Link
      to={p("home")}
      data-testid="site-logo"
      aria-label="Dentel Vietnam — home"
      className={`inline-flex items-center ${className}`}
    >
      {onDark ? (
        <span className="inline-flex items-center rounded-2xl bg-white px-4 py-3 shadow-soft">
          {mark("h-9 w-[99px]")}
        </span>
      ) : (
        mark("h-10 w-[110px] sm:h-12 sm:w-[132px] transition-transform duration-300 hover:scale-[1.03]")
      )}
    </Link>
  );
}
